import { useAuth } from "context/AuthContext";
import { useGlobalConfig } from "context/GlobalConfigContext";
import { BiLogOut } from "react-icons/bi";
import { Link, NavLink } from "react-router-dom";
import trophy from "assets/img/trophy-icon.svg";
import { useEffect, useState } from "react";
import { getNomeUnidade, getPointsUnidade } from "services/profile.service";
import { actionLog } from "services/actionlog.service";
import { FaExternalLinkAlt } from "react-icons/fa";
import { getNovasEntregas } from "services/achievement.service";

require("./styles.scss");

export function NavMenu() {
  const { user } = useAuth();
  const { signOut } = useAuth();
  const { isMenuItemEnabled } = useGlobalConfig();
  const [nomeUnidade, setNomeUnidade] = useState<any>();
  const [pontosUnidade, setPointsUnidade] = useState<any>();
  const [totalEntregas, setTotalEntragas] = useState<any>();

  function handleLinkClass({ isActive }: any) {
    const baseClass = isActive
      ? "active text-white text-center py-1 md:px-2 md:py-2"
      : "bg-opacity-30 text-white text-center py-1 md:px-2 md:py-2 ";
    return `${baseClass} hover:text-white no-underline`;
  }

  async function loadData() {
    if (!user?.extra?.unidade) {
      return;
    }
    const data = await getNomeUnidade(user?.extra.unidade);
    setNomeUnidade(data && data[0] ? data[0].nome : "Sem unidade");

    // const data1 = await getPointsUnidade(user?.extra.unidade);
    // const pts = data1[0] ? data1[0].total : 0;

    // setPointsUnidade(pts);
  }

  async function loadTotalEntregas() {
    const data = await getNovasEntregas(user?._id);
    const total = data[0] ? data[0].total : 0;
    setTotalEntragas(total);
  }

  function handleActionLog(data: any) {
    actionLog("interaction", data);
  }

  useEffect(() => {
    if (!user) return
    loadData();
    loadTotalEntregas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="hidden md:flex md:justify-end md:w-[100%]">
      <div id="container-menu" className="w-full">
        <div className="menu-list flex flex-col md:flex-row md:items-center justify-between w-full max-w-[1300px] mx-auto">
          <div className="w-[50%] flex md:flex md:items-center justify-around unidade">
          <p>
            <strong className="leading-none">
              {nomeUnidade ? nomeUnidade : "----"}
            </strong>
          </p>
          {/* <Link className="points" to="/extrato?unidade=true">
            <p className="w-full uppercase">
              <img className="h-5" src={trophy} alt="Parabéns" />{" "}
              <strong>{pontosUnidade ? pontosUnidade : 0}</strong> pontos mundo
              BRB
            </p>
          </Link> */}
          <Link
            className="points ml-2"
            to="https://mundo.brb.com.br/home"
            target="_blank"
          >
            <p className="w-full ">
              <FaExternalLinkAlt />
              Mundo BRB
            </p>
          </Link>

          <Link
            className="points ml-2"
            to="https://oracleapex.com/ords/r/sumar/campanha/login?session=107011220208109"
            target="_blank"
          >
            <p className="w-full ">
              <FaExternalLinkAlt /> Portal de Apoio
            </p>
          </Link>
        </div>
        <div className="w-[70%] grid grid-cols-1 md:grid-cols-5 gap-1 md:gap-4 md:grid-cols-auto md:flex md:items-center justify-end">
          {isMenuItemEnabled("aCampanha") && (
            <NavLink
              to="/campanha"
              className={handleLinkClass}
              onClick={() =>
                handleActionLog({
                  itemId: "aCampanha",
                  itemTitle: "A CAMPANHA",
                  type: "page_view_custom",
                })
              }
            >
              A campanha
            </NavLink>
          )}
          {isMenuItemEnabled("extrato") && (
            <NavLink
              to="/extrato"
              className={handleLinkClass}
              onClick={() =>
                handleActionLog({
                  itemId: "extrato",
                  itemTitle: "EXTRATO",
                  type: "page_view",
                })
              }
            >
              Extrato
            </NavLink>
          )}
          {isMenuItemEnabled("resgates") && (
            <NavLink
              to="/resgates"
              className={handleLinkClass}
              onClick={() =>
                handleActionLog({
                  itemId: "resgates",
                  itemTitle: "RESGATES",
                  type: "page_view",
                })
              }
            >
              Resgates
            </NavLink>
          )}
          <NavLink
            to="/contato"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "ajuda",
                itemTitle: "AJUDA",
                type: "page_view",
              })
            }
          >
            Ajuda
          </NavLink>
          {isMenuItemEnabled("minhasEntregas") && (
            <NavLink
              to="/minhas-entregas"
              className={`${handleLinkClass} relative`}
              onClick={() =>
                handleActionLog({
                  itemId: "minhasEntregas",
                  itemTitle: "MINHAS ENTREGAS",
                  type: "page_view",
                })
              }
            >
              Meus Pedidos
              {totalEntregas > 0 && (
                <span className="total" title={`Você tem ${totalEntregas} pedido${totalEntregas > 1 ? 's' : ''} enviado${totalEntregas > 1 ? 's' : ''}`}>{totalEntregas}</span>
              )}
            </NavLink>
          )}

          {isMenuItemEnabled("faq") && (
            <NavLink to="/faq" className={handleLinkClass}>
              FAQ
            </NavLink>
          )}
          {isMenuItemEnabled("regulamento") && (
            <NavLink to="/regulamento" className={handleLinkClass}>
              Regulamento
            </NavLink>
          )}
          {isMenuItemEnabled("ganhadores") && (
            <NavLink
              to="/ganhadores"
              className={({ isActive }) =>
                isActive
                  ? 'bg-gray-900 text-white px-4  py-2 font-bold rounded ring-1 ring-blue-dark'
                  : 'text-white border-white px-4  py-2 font-bold rounded ring-1 ring-white'
              }
            >
              GANHADORES
            </NavLink>
          )}

          <button
            type="button"
            onClick={() => signOut()}
            className={handleLinkClass({ isActive: false })}
          >
            <div className="flex items-center justify-center space-x-2 border border-white px-3 py-1 font-bold ring-1 ring-white">
              <div className="">SAIR</div>
              <div>
                <BiLogOut
                  size={16}
                  className="text-white transform rotate-180"
                />
              </div>
            </div>
          </button>
        </div>
        </div>
      </div>
    </div>
  );
}
